<template>
	<div style="width: 1000px;margin: 70px auto;">
		<bar></bar>
		<div style="width: 1000px;height: 30px; margin-top: 20px;;border-bottom: 1px solid #000000;"><span style="font-size: 14px;float: left">首页/订单明细</span></div>
		<div class="order-box">
			<div style="text-align: left;margin: 0 auto;width: 640px;height: 276px;">
				<div style="margin:10px 0 15px 30px;">
					<span style="font-size: 14px;">
						用户姓名：
						<span style="font-size: 13px;padding-left: 15px;">{{ form.staffName }}</span>
						<a href=""></a>
					</span>
				</div>
				<div style="margin:10px 0 15px 30px;">
					<span style="font-size: 14px;">
						送货地址：
						<span style="font-size: 13px;padding-left: 15px;">{{ form.deliveryAddress }}</span>
					</span>
				</div>
				<div style="margin:10px 0 15px 30px;">
					<span style="font-size: 14px;">
						联系电话：
						<span style="font-size: 13px;padding-left: 15px;">{{ form.phone }}</span>
					</span>
				</div>
				<div style="margin:10px 0 15px 30px;">
					<span style="font-size: 14px;">
						订单编号：
						<span style="font-size: 13px;padding-left: 15px;">{{ form.orderCode }}</span>
					</span>
				</div>
				<div style="margin:10px 0 15px 30px;">
					<span style="font-size: 14px;">
						订单金额：
						<span style="font-size: 13px;padding-left: 15px;">￥ {{ form.orderAmount }}</span>
					</span>
				</div>
				<div style="margin:10px 0 15px 30px;">
					<span style="font-size: 14px;">
						订单日期：
						<span style="font-size: 13px;padding-left: 15px;">{{ form.orderTime }}</span>
					</span>
				</div>
				<div style="margin:10px 0 15px 30px;">
					<span style="font-size: 14px;">
						支付方式：
						<span style="font-size: 13px;padding-left: 15px;">{{ form.paymentMethodName }}</span>
					</span>
				</div>
				<div style="margin:10px 0 15px 30px;">
					<span style="font-size: 14px;">
						订单状态：
						<span style="font-size: 13px;padding-left: 15px;">{{ form.orderStatusName }}</span>
					</span>
				</div>
			</div>
		</div>
		<div class="clearfix">
			<div class="vehicle-head">
				<ul class="vehicle-head-font">
					<li>No.</li>
					<li>SKU code</li>
					<li>商品名称</li>
				</ul>
				<ul class="vehicle-head-fontt">
					<li style="display: inline-block;padding-left: 22px;font-size: 13px;">图片</li>
					<li>单价</li>
					<li>数量</li>
					<li click>总价</li>
				</ul>
			</div>
			<div style="width: 700px;margin: 0 auto;">
				<div class="vehicle-middle-box">
					<div style="position: absolute;left:0;top:36%;">
						<img src="../assets/img/cart/bfc1a91.jpg" alt="" />
						<div class="order-numbert"><span>1</span></div>
						<div class="order-twice">
							<span>娇韵诗植物</span>
							<br />
							<span>Clarins lonic</span>
						</div>
						<div class="order-sku"><span>55300</span></div>
						<div>
							<div class="order-money"><span>￥120</span></div>
							<div class="order-number"><span>5</span></div>
							<div class="order-zmoney"><span>120.0</span></div>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 700px;margin: 0 auto;">
				<div class="vehicle-middle-box">
					<div style="position: absolute;left:0;top:36%;">
						<img src="../assets/img/cart/bfc1a91.jpg" alt="" />
						<div class="order-numbert"><span>2</span></div>
						<div class="order-twice">
							<span>娇韵诗植物</span>
							<br />
							<span>Clarins lonic</span>
						</div>
						<div class="order-sku"><span>55300</span></div>
						<div>
							<div class="order-money"><span>￥120</span></div>
							<div class="order-number"><span>5</span></div>
							<div class="order-zmoney"><span>120.0</span></div>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 700px;margin: 0 auto;">
				<div class="vehicle-middle-box">
					<div style="position: absolute;left:0;top:36%;">
						<img src="../assets/img/cart/bfc1a91.jpg" alt="" />
						<div class="order-numbert"><span>3</span></div>
						<div class="order-twice">
							<span>娇韵诗</span>
							<br />
							<span>Clarins lonic</span>
						</div>
						<div class="order-sku"><span>55300</span></div>
						<div>
							<div class="order-money"><span>￥120</span></div>
							<div class="order-number"><span>5</span></div>
							<div class="order-zmoney"><span>120.0</span></div>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 700px;margin: 0 auto;">
				<div class="vehicle-middle-box">
					<div style="position: absolute;left:0;top:36%;">
						<div class="order-numbert"><span>4</span></div>
						<img src="../assets/img/cart/bfc1a91.jpg" alt="" />
						<div class="order-twice">
							<span>娇韵诗</span>
							<br />
							<span>Clarins lonic</span>
						</div>
						<div class="order-sku"><span>55400</span></div>
						<div>
							<div class="order-money"><span>￥120</span></div>
							<div class="order-number"><span>5</span></div>
							<div class="order-zmoney"><span>120.0</span></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import bar from '@/components/bar.vue';
export default {
	data() {
		return {
			tableData: [
				{
					date: '1',
					name: '55110',
					province: '植物精油润体乳',
					// city: '',
					address: '100.00',
					zip: 200333,
					right: '12'
				},
				{
					date: '2',
					name: '55220',
					province: '植物精油润体乳',
					// city: '普陀区',
					address: '200.00',
					zip: 200333,
					right: '12'
				},
				{
					date: '3',
					name: '55330',
					province: '植物精油润体乳',
					// city: '普陀区',
					address: '300.00',
					zip: 200333,
					right: '12'
				},
				{
					date: '4',
					name: '55440s',
					province: '植物精油润体乳',
					// city: '普陀区',
					address: '400.00',
					zip: 200333,
					right: '12'
				}
			],
			sizeForm: {
				name: '111',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: '',
				desc1: '',
				desc2: ''
			},
			form: {
				orderAmount: '',
				orderCode: '',
				orderStatusName: '',
				paymentMethodName: '',
				phone: '',
				staffName: '',
				orderTime: '',
				deliveryAddress: ''
			}
		};
	},
	methods: {
		clickbar() {
			this.$router.push({ path: '/vehicle' });
		},
		onSubmit() {
			console.log('submit!');
		},
		handleClick(row) {
			console.log(row);
		}
	},
	created() {
		// var key = 'BE84C0A057A730E96265CBCC61E0EB9E';
		this.$axiso
			.post('http://47.104.74.205:8090/api-clarins/order/info', {
				id: '53BEF7520B314A1E934B8A833C79AEF5'
				// headers: {
				// 	Authorization: 'Bearer ' + this.$cookies.get('token'),
				// 	key: 'BE84C0A057A730E96265CBCC61E0EB9E'
				// }
			})
			.then(res => {
				this.form.orderAmount = res.data.data.orderAmount;
				this.form.orderCode = res.data.data.orderCode;
				this.form.orderStatusName = res.data.data.orderStatusName;
				this.form.paymentMethodName = res.data.data.paymentMethodName;
				this.form.staffName = res.data.data.staffName;
				this.form.phone = res.data.data.phone;
				this.form.orderTime = res.data.data.orderTime;
				this.form.deliveryAddress = res.data.data.deliveryAddress;
			});
	},
	components: {
		bar
	}
};
</script>

<style scoped="">
a {
	text-decoration: none;
}
.list-bar-ui {
	text-align: left;
}
.list-bar-ui li {
	list-style: none;
	color: white;
	font-weight: 200;
	margin-left: 20px;
	cursor: pointer;
	display: inline-block;
}
.top-bar {
	position: fixed;
	top: 0;
	bottom: auto;
	left: 0;
	right: auto;
	z-index: 80;
	width: 100%;
}
.top-color {
	height: 40px;
	background: #be0f34;
}
.top-color img {
	float: right;
	width: 209px;
	margin-top: 8px;
	padding-right: 300px;
}

.car-bar-box {
	cursor: pointer;
	width: 30px;
	height: 30px;
	background-image: url(../assets/img/cheo.png);
	background-size: 100%;
	background-repeat: no-repeat;
	position: absolute;
	top: 3px;
	right: 90px;
}
.order-box {
	margin: 24px auto;
	width: 600px;
}
.order-box a {
	text-decoration: none;
}
.el-table td {
	text-align: center;
}
.vehicle-head {
	width: 792px;
	height: 40px;
	background-color: #e5e5e5;
	margin: 0 auto;
}
.vehicle-head-font {
	float: left;
	font-size: 12px;
	line-height: 40px;
	margin-left: 10px;
}
.vehicle-head-font li {
	display: inline-block;
	padding-left: 56px;
	font-size: 13px;
}
.vehicle-head-fontt {
	float: right;
	font-size: 12px;
	line-height: 40px;
	margin-left: 10px;
}
.vehicle-head-fontt li {
	display: inline-block;
	padding-right: 73px;
	font-size: 13px;
}
.vehicle-p-box {
	text-align: left;
	margin-left: 30px;
	float: right;
}
.vehicle-p-box p {
	font-size: 12px;
	color: #000000;
	padding-right: 20px;
	display: inline-block;
}
.vehicle-head-p {
	font-size: 12px;
	color: #000000;
	display: inline-block;
	float: left;
	padding-left: 20px;
}
i {
	width: 225px;
	height: 2px;
	border-bottom: 1px solid #e5e5e5;
	float: right;
	margin: 6px 9px 0 0;
}
.vehicle-middle-box {
	width: 741px;
	border-bottom: 1px solid #e5e5e5;
	height: 100px;
	position: relative;
	right: 21px;
}
.vehicle-middle-box img {
	width: 80px;
	height: 80px;
	position: absolute;
	top: -23px;
	left: 340px;
}
.order-sku {
	position: absolute;
	top: 10px;
	left: 129px;
	width: 200px;
	font-size: 13px;
	text-align: left;
}
.order-money {
	position: absolute;
	top: 2px;
	left: 466px;
	width: 200px;
	font-size: 13px;
	text-align: left;
}
.order-number {
	position: absolute;
	top: 2px;
	left: 579px;
	width: 200px;
	font-size: 13px;
	text-align: left;
}
.order-zmoney {
	position: absolute;
	top: 2px;
	left: 663px;
	width: 200px;
	font-size: 13px;
	text-align: left;
}
.order-numbert {
	position: absolute;
	top: 9px;
	left: 44px;
	width: 200px;
	font-size: 13px;
	text-align: left;
}
.order-twice {
	position: absolute;
	top: -3px;
	left: 226px;
	width: 200px;
	font-size: 13px;
	text-align: left;
}
</style>
